export type SearchResultType = 'apps' | 'news' | 'dashboards' | 'belivpedia';

export interface SearchResult {
  type: SearchResultType;
  id: string | number;
  title: string;
  description?: string;
  /** Ruta de navegación (ej: '/news', '/dashboards/view/25', '/apps/...') */
  url: string;
  icon?: string;
  image?: string;
  tags?: string[];
}
